const rangeElement = document.getElementById('product-count-range');

if (rangeElement) {
  let visibleCount = 0;

  // Collection page?
  const collectionContent = document.querySelector('.section-collection__content');
  if (collectionContent) {
    visibleCount = collectionContent.querySelectorAll('.card-product').length;
  }

  // Search page? (overrides if present, but in practice you'll only have one)
  const searchContent = document.querySelector('.section-search__content');
  if (searchContent) {
    visibleCount = searchContent.querySelectorAll('.card-product').length;
  }

  if (visibleCount > 0) {
    // Example: "1-10 of 10 Products"
    rangeElement.textContent =
      `1-${visibleCount} of ${visibleCount} Products`;
  } else {
    rangeElement.textContent = '0 Products';
  }
}
